import type { IInfiniteTerminologiesResponse } from "../../types";

import classes from "./styles.module.scss";

import { Typography } from "@/components/atoms/typography";

export function TerminologyItem(props: IInfiniteTerminologiesResponse) {
  const { code, description, value } = props;

  return (
    <div className={classes.terminologyCard}>
      <div className={classes.terminologyCard__header}>
        <Typography
          fontWeight={"medium"}
          fontFamily={"dana"}
          fontSize={"md-high"}
        >
          {value}
        </Typography>
        <Typography
          fontFamily={"dana"}
          fontSize={"xs"}
          fontWeight={"regular"}
          variant={"caption1"}
        >
          {code}
        </Typography>
      </div>
      {description?.trim() && (
        <Typography variant={"description2"}>{description}</Typography>
      )}
    </div>
  );
}
